export default __webpack_public_path__ + "static/media/Comfort-_-Efficiency.2cc8fd9f.jpg";